import axios from "axios";
import { Config } from "../config";
import { useAuth } from "@clerk/clerk-react";
import { useEffect } from "react";

// Create axios instances
const mock_api = axios.create({
  baseURL: "https://a1e4a6a8-42f9-4f0c-b60f-2e2f82aca35d.mock.pstmn.io/api/v1",
});
const api = axios.create({
  baseURL: Config.apiGateway.URL,
});

// Chat service URL - automatically selected based on environment
// For local testing: 'https://localhost:7259' (HTTPS) - direct connection
// For QA/Production: Use API Gateway like other services (chat service is internal-only)
const getChatServiceUrl = () => {
  const stage = process.env.REACT_APP_STAGE;
  if (!stage || stage === 'local') {
    // Local development: call service directly
    return 'https://localhost:7259';
  }
  // For QA, Release, or Prod: use API Gateway (chat service is not publicly accessible)
  return Config.apiGateway.URL;
};

const chatServiceUrl = getChatServiceUrl();

// Helper function to build chat API routes
// In local: uses direct routes (e.g., "/chat/sessions")
// In QA/Prod: uses API Gateway routes (e.g., "/ChatDiligent/chat/sessions")
export const getChatApiRoute = (route) => {
  const stage = process.env.REACT_APP_STAGE;
  if (!stage || stage === 'local') {
    // Local development: use direct routes
    return route;
  }
  // QA/Prod: use API Gateway routes - prepend "/ChatDiligent"
  const cleanRoute = route.startsWith('/') ? route.substring(1) : route;
  return `/ChatDiligent/${cleanRoute}`;
};

// Create a separate axios instance for the chat service
// In local: uses direct service URL (localhost)
// In QA/Prod: uses API Gateway URL (same as other services)
export const chatApi = axios.create({
  baseURL: chatServiceUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

const useApiInterceptor = () => {
  const { getToken } = useAuth();

  useEffect(() => {
    const interceptor = api.interceptors.request.use(
      async (config) => {
        try {
          const token = await getToken();
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          } else {
          }
        } catch (error) {
          console.error("Error fetching token", error);
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    return () => {
      api.interceptors.request.eject(interceptor);
    };
  }, [getToken]);
};

const useChatApiInterceptor = () => {
  const { getToken } = useAuth();

  useEffect(() => {
    const interceptor = chatApi.interceptors.request.use(
      async (config) => {
        try {
          const token = await getToken();
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          }
        } catch (error) {
          console.error("Error fetching token for chat API", error);
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    return () => {
      chatApi.interceptors.request.eject(interceptor);
    };
  }, [getToken]);
};

export { mock_api, api, useApiInterceptor, useChatApiInterceptor };
